if ( typeof CSSSliderNavigation !== 'function' ) {

	class CSSSliderNavigation extends HTMLElement {
		
		constructor(){
      super();
    }

    connectedCallback(){
      this.slider = document.getElementById(`slider-${this.dataset.sliderId}`);
      if ( !this.slider ) {
        setTimeout(()=>{
          this.slider = document.getElementById(`slider-${this.dataset.sliderId}`);
          this.preInit();
        }, 1000);
      } else {
        this.preInit();
      }
    }

    preInit() {
      if ( this.slider.classList.contains('kt-enabled') ) {
        this.init();
      } else {
        this.slider.addEventListener('ready', ()=>{
          this.init();
        })
      }
    }

    init() {

      const prevButton = this.querySelector('[data-js-slider-prev]'),
            nextButton = this.querySelector('[data-js-slider-next]'),
            indexElement = this.querySelector('[data-js-slider-index]'),
            lengthElement = this.querySelector('[data-js-slider-length]'),
            paginationElement = this.querySelector('[data-js-slider-pagination]');

      this.paginationDots = [];

      if ( lengthElement ) {
        lengthElement.textContent = this.slider.length;
      }

      if ( paginationElement ) {
        this.initPagination(paginationElement);
      }

      prevButton?.addEventListener('click', e=>{
        this.slider.changeSlide('prev');
      });
      nextButton?.addEventListener('click', e=>{
        this.slider.changeSlide('next');
      });

      prevButton?.classList.add('kt-disabled');
      this.slider.addEventListener('change', ()=>{
        nextButton?.classList.remove('kt-disabled');
        prevButton?.classList.remove('kt-disabled');
        if ( this.slider.index == 0 ) {
          prevButton?.classList.add('kt-disabled');
        } else if ( this.slider.index + 1 == this.slider.length ) { 
          nextButton?.classList.add('kt-disabled');
        }
        if ( indexElement ) {
          indexElement.textContent = this.slider.index + 1;
        }

        if ( this.paginationDots.length > 0 ) {
          this.paginationDots.forEach(dot=>{dot.classList.remove('kt-active')});
          this.paginationDots[this.slider.index].classList.add('kt-active');
        }
      });

      this.slider.addEventListener('reset', ()=>{
        this.reset();
        if ( lengthElement ) {
          lengthElement.textContent = this.slider.length;
        }
        if ( paginationElement ) {
          this.initPagination(paginationElement);
        }
      });

      this.removeAttribute('style');
      this.reset();

    }

    initPagination(paginationElement){
      paginationElement.innerHTML = '';
      this.paginationDots = [];
      for ( let i = 0; i < this.slider.length; i++ ) {
        let dot = document.createElement('span');
        dot.classList.add('kt-css-slider-dot');
        dot.dataset.index = i;
        paginationElement.appendChild(dot);
        dot.addEventListener('click', (e)=>{
          this.slider.changeSlide(e.target.dataset.index);
        });
        dot.setAttribute('aria-label', window.KROWN.settings.locales.slider_thumbnail_label.replace('{{ count }}', i+1));
        dot.setAttribute('role', 'button');
        dot.setAttribute('tabindex', 0);
        dot.addEventListener('keydown', e=>{
          if ( e.keyCode == window.KEYCODES.RETURN ) {
            dot.click();
          }
        });
      } 
      paginationElement.style.setProperty('--kt-size', this.slider.length);
      this.paginationDots = paginationElement.querySelectorAll('.kt-css-slider-dot');
      this.paginationDots[0].classList.add('kt-active');
    }

    reset(){
      if ( this.slider.length <= 1 ) {
        this.classList.add('kt-hide');
      } else {
        this.classList.remove('kt-hide');
      }
    }

  }

  if ( typeof customElements.get('css-slider-navigation') == 'undefined' ) {
		customElements.define('css-slider-navigation', CSSSliderNavigation);
	}

}